/**
 * Auction video values use the API's optional string contract; an absent value is undefined.
 */
const reservedYoutubeEmbedIds = ['videoseries', 'live_stream']

export function getYoutubeVideoId(value?: string | null): string | undefined {
  const input = typeof value === 'string' ? value.trim() : undefined

  if (!input)
    return undefined

  if (!reservedYoutubeEmbedIds.includes(input) && /^[\w-]{11}$/.test(input))
    return input

  const iframeStart = input.search(/<iframe\b/i)
  const iframeEnd = iframeStart === -1 ? -1 : input.indexOf('>', iframeStart)
  const iframeTag = iframeEnd === -1 ? undefined : input.slice(iframeStart, iframeEnd + 1)
  const iframeMatch = iframeTag?.match(/\ssrc\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i)
  const source = iframeMatch
    ? (iframeMatch[1] ?? iframeMatch[2] ?? iframeMatch[3] ?? '')
    : input
  const urlSource = source.startsWith('//')
    ? `https:${source}`
    : /^[a-z][a-z\d+.-]*:\/\//i.test(source)
      ? source
      : `https://${source}`

  try {
    const url = new URL(urlSource)
    const host = url.hostname.toLowerCase()
    const pathParts = url.pathname.split('/').filter(Boolean)
    const route = pathParts[0] ?? ''
    let videoId: string | null | undefined

    if (host === 'youtu.be' || host === 'www.youtu.be') {
      videoId = pathParts[0]
    }
    else if (host === 'youtube.com' || host.endsWith('.youtube.com') || host === 'youtube-nocookie.com' || host.endsWith('.youtube-nocookie.com')) {
      if (route === 'watch')
        videoId = url.searchParams.get('v') || pathParts[1]
      else if (['embed', 'shorts', 'live', 'v', 'e', 'vi'].includes(route))
        videoId = pathParts[1] || url.searchParams.get('v')
    }

    return videoId && !reservedYoutubeEmbedIds.includes(videoId) && /^[\w-]{11}$/.test(videoId) ? videoId : undefined
  }
  catch {
    return undefined
  }
}
